import { ExportButton } from '../components/ExportButton';
import { PageHeader } from '../components/PageHeader';
import { ScoreBadge } from '../components/ScoreBadge';
import { orchestrationScores } from '../lib/seedData';

export function ScoresPage() {
  return (
    <section className="page">
      <PageHeader title="Orchestration Score list" description="Weighted score sheets for task-agent-tool combinations." actions={<ExportButton />} />
      <div className="card table-wrap">
        <table>
          <thead>
            <tr>
              <th>Task</th>
              <th>Score</th>
              <th>Agents</th>
              <th>Tools</th>
              <th>Difficulty</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            {orchestrationScores.map((score) => (
              <tr key={score.id}>
                <td>{score.taskTypeId}</td>
                <td><ScoreBadge score={score.score} /></td>
                <td>{score.agentCombination.join(', ')}</td>
                <td>{score.toolCombination.join(', ')}</td>
                <td>{score.difficulty}</td>
                <td>{score.costLevel}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
